import { isSSR } from 'src/helpers/ssr';
import type { Experiments } from './types';
import { getUserId } from '../getUserId';

// значение по умолчанию когда фича объявлена, но почему-то пользователь не попал ни в одну из групп
const DEFAULT_VALUE = 'default';

/**
 * Функция для получения значения фичи
 */
export const getFlagSigmaOptionByName = async <Key extends keyof Experiments>(
  flagName: Key,
): Promise<Experiments[Key] | undefined> => {
  // проверяем что мы вне окружения SSR, потому что Sigma разваливает SSR
  if (isSSR) return undefined;

  // при любой ошибке (упавший чанк, недоступная Sigma, throw из SDK)
  // деградируем к «флага нет» — undefined, чтобы не ронять фичу и не вешать хук в isLoading
  try {
    const userId = getUserId();

    const { sigmaInit } = await import(
      /* webpackChunkName: "sigmaInit" */ './sigmaInit'
    );
    const sigma = await sigmaInit(userId);

    const flagValue = await sigma.checkFlag(flagName);

    if (flagValue === DEFAULT_VALUE) {
      return undefined;
    }

    return flagValue;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`Sigma feature toggle "${flagName}" failed:`, err);

    return undefined;
  }
};

/**
 * Функция для проверки фичи на равенство значению
 */
export const getFlagSigmaHasAnOption = async <Key extends keyof Experiments>(
  featureName: Key,
  optionName: Experiments[Key],
): Promise<boolean | undefined> => {
  const value = await getFlagSigmaOptionByName(featureName);

  return value && value === optionName;
};
